import React, { useEffect, useState } from 'react';
import useAxios from '../utils/useAxios';
import Swal from 'sweetalert2';
import { FaDownload, FaCheck, FaTimes, FaUsers, FaMoneyBill, FaExclamationTriangle, FaCalendarAlt, FaInfoCircle, FaSearch } from 'react-icons/fa';
import { FiAlertTriangle, FiSunrise, FiSunset, FiArrowDownCircle, FiCoffee } from 'react-icons/fi'; // Ajouter ces imports
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Link } from 'react-router-dom';
import { useSidebar } from '../context/SidebarContext';
import OrganisationSelector from '../components/OrganisationSelector';
import styles from '../styles/PenalitesPage';
import { useAuth } from '../context/AuthContext';

const PenalitesPage = () => {
  const axiosInstance = useAxios();
  const [penalites, setPenalites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ 
    count: 0, 
    next: null, 
    previous: null, 
    totalPages: 1 
  });
  const [stats, setStats] = useState({ total: 0, totalMontant: 0, totalEmployes: 0, periode: '' });
  const [showEmployesModal, setShowEmployesModal] = useState(false);
  const [employesConcernes, setEmployesConcernes] = useState([]);
  const [loadingEmployes, setLoadingEmployes] = useState(false);
  const { sidebarVisible } = useSidebar();
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedDate, setSelectedDate] = useState('');

  // États pour la gestion des organisations
  const [selectedOrganisation, setSelectedOrganisation] = useState('');
  const [currentOrganisation, setCurrentOrganisation] = useState(null);
  const { user } = useAuth();

  const moisOptions = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ];
  const currentYear = new Date().getFullYear();

  const [moisSelectionne, setMoisSelectionne] = useState(() => {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    return `${month}-${now.getFullYear()}`;
  });

  const formatMoisForAPI = (mois) => {
    const [month, year] = mois.split('-');
    return `${year}-${month}`;
  };

  const periodStyles = {
    exceptionnellePeriod: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '12px',
      backgroundColor: '#fff3cd',
      color: '#856404',
      border: '1px solid #ffeaa7',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    matinPeriod: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '12px',
      backgroundColor: '#d1ecf1',
      color: '#0c5460',
      border: '1px solid #bee5eb',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    apresMidiPeriod: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '12px',
      backgroundColor: '#f8d7da',
      color: '#721c24',
      border: '1px solid #f5c6cb',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    descentePeriod: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '12px',
      backgroundColor: '#d4edda',
      color: '#155724',
      border: '1px solid #c3e6cb',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    pausePeriod: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '12px',
      backgroundColor: '#e2e3e5',
      color: '#383d41',
      border: '1px solid #d6d8db',
      fontSize: '0.85rem',
      fontWeight: '500'
    },
    defaultPeriod: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      borderRadius: '12px',
      backgroundColor: '#e9ecef',
      color: '#495057',
      border: '1px solid #dee2e6',
      fontSize: '0.85rem',
      fontWeight: '500'
    }
  };

  const formatPeriode = (periode, motifSortie) => {
    if (periode === "autre") {
      return (
        <span title={motifSortie || 'Sortie hors période normale'} style={periodStyles.exceptionnellePeriod}>
          <FiAlertTriangle /> Exceptionnelle
        </span>
      );
    } else if (periode === "matin") {
      return (
        <span style={periodStyles.matinPeriod}>
          <FiSunrise /> Matin
        </span>
      );
    } else if (periode === "apres_midi") {
      return (
        <span style={periodStyles.apresMidiPeriod}>
          <FiSunset /> Après-midi
        </span>
      );
    } else if (periode === "descente") {
      return (
        <span style={periodStyles.descentePeriod}>
          <FiArrowDownCircle /> Descente
        </span>
      );
    } else if (periode === "pause") {
      return (
        <span style={periodStyles.pausePeriod}>
          <FiCoffee /> Pause
        </span>
      );
    } else {
      return (
        <span style={periodStyles.defaultPeriod}>
          {periode?.charAt(0).toUpperCase() + periode?.slice(1).replace('_', ' ') || '-'}
        </span>
      );
    }
  };

  const handleOrganisationChange = (orgId, org) => {
    setSelectedOrganisation(orgId);
    setCurrentOrganisation(org);
    
    fetchPenalites(1, orgId);
    fetchStats(orgId);
  };

  // CORRECTION : Fonction pour calculer la page actuelle à partir des URLs
  const getCurrentPageFromUrls = () => {
    if (pagination.previous) {
      const pageMatch = pagination.previous.match(/page=(\d+)/);
      if (pageMatch) {
        return parseInt(pageMatch[1]) + 1;
      }
    } else if (pagination.next) {
      const pageMatch = pagination.next.match(/page=(\d+)/);
      if (pageMatch) {
        return parseInt(pageMatch[1]) - 1;
      }
    }
    return 1;
  };

  const currentPage = getCurrentPageFromUrls();

  const fetchPenalites = async (targetPage = 1, orgId = selectedOrganisation, useUrl = null) => {
    if (!orgId) return; 
    
    setLoading(true);
    try {
      let url;
      if (useUrl) {
        url = useUrl;
      } else {
        const params = new URLSearchParams({
          page: targetPage,
          search,
          mois: moisSelectionne,
          date: selectedDate,
          organisation: orgId,
          page_size: pageSize === 'all' ? totalCount : pageSize
        });
        url = `/pointage/penalites/?${params}`;
      }
      
      const response = await axiosInstance.get(url);
      setPenalites(response.data.results);
      setTotalCount(response.data.count);

      if (pageSize === 'all') {
        setPagination({ 
          count: response.data.count,
          next: response.data.next,
          previous: response.data.previous,
          totalPages: 1 
        });
      } else {
        setPagination({ 
          count: response.data.count,
          next: response.data.next,
          previous: response.data.previous,
          totalPages: Math.ceil(response.data.count / pageSize) 
        });
      }

      if (!useUrl) {
        setPage(targetPage);
      }
    } catch (error) {
      console.error("Erreur détaillée:", error);
      Swal.fire({ icon: 'error', title: 'Erreur', text: 'Impossible de charger les pénalités.' });
    } finally {
      setLoading(false);
    }
  };

  const generatePageSizeOptions = () => {
    const options = [10, 20, 30, 50];
    
    if (totalCount > 50 && !options.includes(totalCount)) {
      options.push(totalCount);
    }
    
    options.push('all');
    return options;
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) fetchPenalites(newPage);
  };

  const handleNextPage = () => {
    if (pagination.next) {
      fetchPenalites(null, selectedOrganisation, pagination.next);
    }
  };

  const handlePrevPage = () => {
    if (pagination.previous) {
      fetchPenalites(null, selectedOrganisation, pagination.previous);
    }
  };

  const fetchStats = async (orgId = selectedOrganisation) => {
    if (!orgId) return;
    
    try {
      const params = new URLSearchParams({
        mois: moisSelectionne,
        date: selectedDate,
        organisation: orgId
      });
      const res = await axiosInstance.get(`/pointage/penalites/stats/?${params}`);
      
      let periodeText = '';
      if (selectedDate) {
        periodeText = `Date: ${selectedDate}`;
      } else {
        periodeText = new Date(formatMoisForAPI(moisSelectionne) + '-01').toLocaleDateString('fr-FR', { 
          month: 'long', 
          year: 'numeric' 
        });
      }
      
      setStats({
        total: res.data.total_penalites,
        totalMontant: res.data.montant_total,
        totalEmployes: res.data.employes_concernes,
        periode: periodeText
      });
    } catch (e) {
      console.error("Erreur fetchStats:", e);
      Swal.fire({ 
        icon: 'error', 
        title: 'Erreur', 
        text: 'Impossible de charger les statistiques.' 
      });
    }
  };

  const fetchEmployesConcernes = async () => {
    setLoadingEmployes(true);
    try {
      const params = new URLSearchParams({
        mois: moisSelectionne,
        date: selectedDate,
        organisation: selectedOrganisation
      });
      const res = await axiosInstance.get(`/pointage/penalites/stats/?${params}`);
      setEmployesConcernes(res.data.employes_details || []);
      setShowEmployesModal(true);
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Erreur', text: 'Impossible de charger les employés concernés.' });
    } finally {
      setLoadingEmployes(false);
    }
  };

  useEffect(() => {
    if (selectedOrganisation) {
      fetchPenalites(1);
      fetchStats();
    }
  }, [search, moisSelectionne, selectedDate, pageSize, selectedOrganisation]);

  const validerPenalite = async (id, est_valide) => {
    try {
      await axiosInstance.patch(`/pointage/penalites/${id}/`, { est_valide });
      Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: est_valide ? 'Pénalité validée' : 'Pénalité annulée',
      });
    
      fetchPenalites(currentPage);
      fetchStats();
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Erreur', text: 'Action échouée.' });
    }
  };

  const formatHeure = (raison) => {
    const match = raison?.match(/\d{2}:\d{2}/);
    return match ? `Retard ${match[0]}` : raison || '-';
  };

  const fetchAllPenalites = async () => {
    try {
      let allPenalites = [];
      let nextUrl = `/pointage/penalites/?search=${search}&mois=${moisSelectionne}&date=${selectedDate}&organisation=${selectedOrganisation}&page_size=1000`;
      
      while (nextUrl) {
        const response = await axiosInstance.get(nextUrl);
        allPenalites = [...allPenalites, ...response.data.results];
        nextUrl = response.data.next;
      }
      return allPenalites;
    } catch (err) {
      console.error("Erreur lors de la récupération de toutes les pénalités", err);
      return [];
    }
  };

  const handleExportPDF = async () => {
    setLoading(true);
    try {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.text(`Rapport des Pénalités - ${currentOrganisation?.nom || ''}`, 14, 20);

      let periodeText = '';
      if (selectedDate) {
        periodeText = `Date: ${selectedDate}`;
      } else {
        periodeText = `Mois: ${new Date(formatMoisForAPI(moisSelectionne) + '-01').toLocaleDateString('fr-FR', { 
          month: 'long', 
          year: 'numeric' 
        })}`;
      }
      doc.setFontSize(12);
      doc.text(periodeText, 14, 30);

      const allPenalites = await fetchAllPenalites();

      const tableColumn = ["Nom", "Prénom", "Date", "Période", "Montant", "Raison", "Statut"];
      const tableRows = [];

      allPenalites.forEach((p) => {
        const { prenom, nom } = splitNomPrenom(p.employe_nom_complet);
        
        const montant = typeof p.montant === 'string' ? parseFloat(p.montant) : p.montant;
        
        let periodeFormatee = '-';
        if (p.periode === "autre") {
          periodeFormatee = "Exceptionnelle";
        } else if (p.periode) {
          periodeFormatee = p.periode.charAt(0).toUpperCase() + p.periode.slice(1).replace('_', ' ');
        }
        
        tableRows.push([
          nom,
          prenom,
          new Date(p.presence_date).toLocaleDateString(),
          periodeFormatee, 
          montant + ' F CFA',
          formatHeure(p.raison),
          p.est_valide ? 'Validée' : 'Non validée',
        ]);
      });

      const totalPenalites = allPenalites.length;
      const totalMontant = allPenalites.reduce((sum, p) => {
        const montant = typeof p.montant === 'string' ? parseFloat(p.montant) : p.montant;
        return sum + montant;
      }, 0);
      
      const totalValidees = allPenalites.filter(p => p.est_valide).length;

      doc.setFontSize(12);
      const montantFormate = totalMontant.toLocaleString('fr-FR').replace(/\s/g, '.');
      doc.text(`Totaux: Pénalités: ${totalPenalites} | Validées: ${totalValidees} | Montant: ${montantFormate} F CFA`, 14, 40);

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows,
        startY: 50,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [27, 1, 155] },
      });

      const fileName = `penalites_${selectedDate || moisSelectionne}_${new Date().toLocaleDateString().replace(/\//g, '-')}_${currentOrganisation?.nom || ''}.pdf`;
      doc.save(fileName);
    } catch (err) {
      console.error("Erreur lors de la génération du PDF", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredPenalites = penalites.filter((p) =>
    p.employe_nom_complet.toLowerCase().includes(search.toLowerCase()) ||
    (p.raison && p.raison.toLowerCase().includes(search.toLowerCase()))
  );

  const splitNomPrenom = (nomComplet) => {
    const [prenom, ...nomRest] = nomComplet.split(' ');
    return { prenom, nom: nomRest.join(' ') };
  };

  return (
    <div style={{...styles.container, marginLeft: sidebarVisible ? 250 : 0}}>
      <div className="text-center mb-3">
        <h3 style={styles.header}>Pénalités de Retard</h3>
        <hr style={styles.hr} />
      </div>

      {/* Header avec sélecteur d'organisation réutilisable */}
      <div style={styles.organisationHeader}>
        <OrganisationSelector 
          onOrganisationChange={handleOrganisationChange}
          selectedOrganisation={selectedOrganisation}
        />

        {currentOrganisation && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: '#666', fontSize: '14px' }}>
              Pénalités pour cette organisation
            </span>
          </div>
        )}
      </div>

      {currentOrganisation ? (
        <>
          {/* Statistiques */}
          <div className="row text-center mb-4">
            <div className="col-md-3">
              <div style={styles.cardStats}>
                <FaExclamationTriangle size={26} color="#f39c12" />
                <h5 className="mt-2">{stats.total}</h5>
                <p className="text-muted mb-0">Pénalités totales</p>
              </div>
            </div>
            <div className="col-md-3">
              <div style={styles.cardStats}>
                <FaUsers size={26} color="#1B019B" />
                <h5 className="mt-2">{stats.totalEmployes}</h5>
                <p className="text-muted mb-0">Employés concernés</p>
                <button 
                  onClick={fetchEmployesConcernes}
                  style={styles.detailsButton}
                  disabled={loadingEmployes}
                  aria-label="Afficher les employés concernés"
                >
                  {loadingEmployes ? (
                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  ) : (
                    <FaInfoCircle size={12} className="me-1" />
                  )}
                  Détails
                </button>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ ...styles.cardStats, ...styles.cardStatsPenalite }}>
                <FaMoneyBill size={26} color="#dc3545" />
                <h5 className="mt-2">{stats.totalMontant.toLocaleString()} FCFA</h5>
                <p className="mb-0" style={{ color: '#dc3545' }}>Montant total</p>
              </div>
            </div>
            <div className="col-md-3">
              <div style={styles.cardStats}>
                <FaCalendarAlt size={26} color="#2980b9" />
                <h5 className="mt-2">{stats.periode}</h5>
                <p className="text-muted mb-0">Période</p>
              </div>
            </div>
          </div>

          {/* Filtres */}
          <div style={styles.filterContainer}>
            <div style={styles.filterGroup}>
              <FaSearch style={styles.filterIcon} />
              <input
                type="text"
                placeholder="Rechercher employé..."
                style={styles.searchBar}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            
            <div style={styles.filterGroup}>
              <FaCalendarAlt style={styles.filterIcon} />
              <select
                style={styles.select}
                value={moisSelectionne}
                onChange={(e) => setMoisSelectionne(e.target.value)}
              >
                {Array.from({ length: 12 }, (_, i) => {
                  const month = (i + 1).toString().padStart(2, '0');
                  return (
                    <option key={i} value={`${month}-${currentYear}`}>
                      {moisOptions[i]} {currentYear}
                    </option>
                  );
                })}
              </select>
            </div>
            
            <div style={styles.filterGroup}>
              <FaCalendarAlt style={styles.filterIcon} />
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                style={styles.dateInput}
              />
            </div>
            
            <div style={styles.filterGroup}>
              <label style={styles.pageSizeLabel}>Afficher :</label>
              <select
                style={styles.select}
                value={pageSize}
                onChange={(e) => {
                  setPageSize(e.target.value === 'all' ? 'all' : parseInt(e.target.value));
                }}
                disabled={loading}
              >
                {generatePageSizeOptions().map((size, idx) => (
                  <option key={idx} value={size}>
                    {size === 'all' ? 'Tous' : size}
                  </option>
                ))}
              </select>
            </div>
            {(user?.is_super_admin || user?.permissions?.includes("EXPORT_PDF")) && (
            <div>
              <button
                onClick={handleExportPDF}
                disabled={loading}
                style={styles.exportButton}
              >
                <FaDownload style={{ marginRight: '8px' }} />
                {loading ? 'Génération...' : 'Exporter PDF'}
              </button>
            </div>
            )}
          </div>

          {/* Tableau des pénalités */}
          <div className="card shadow-sm mb-4" style={{ borderRadius: '15px', border: 'none' }}>
            <div className="card-body table-responsive p-0">
              {loading ? (
                <p className="text-center py-4">Chargement...</p>
              ) : (
                <table className="table table-hover text-center align-middle m-0">
                  <thead style={styles.tableHeader}>
                    <tr>
                      <th>Prénom</th>
                      <th>Nom</th>
                      <th>Date</th>
                      <th>Période</th> 
                      <th>Montant</th>
                      <th>Raison</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredPenalites.length ? (
                      filteredPenalites.map((p) => {
                        const { prenom, nom } = splitNomPrenom(p.employe_nom_complet);
                        return (
                          <tr key={p.id}>
                            <td>{prenom}</td>
                            <td>{nom}</td>
                            <td>{new Date(p.presence_date).toLocaleDateString()}</td>
                            <td>
                             
                              {formatPeriode(p.periode, p.motif_sortie)}
                            </td>
                            <td style={{ color: 'red' }}>{p.montant} F CFA</td>
                            <td>{formatHeure(p.raison)}</td>
                            <td>
                              {p.est_valide ? (
                                <span className="badge bg-success">Validée</span>
                              ) : (
                                <span className="badge bg-warning text-dark">Non validée</span>
                              )}
                            </td>
                            <td>
                              <div style={styles.actionButtons}>
                                {(user?.is_super_admin || user?.permissions?.includes("APPROVE_PENALTY")) && (
                                <button
                                  style={styles.validateButton}
                                  onClick={() => validerPenalite(p.id, true)}
                                  disabled={p.est_valide}
                                  title="Valider la pénalité"
                                >
                                  <FaCheck style={{ marginRight: 4, fontSize: '0.9rem' }} /> Valider
                                </button>
                                )}
                                {(user?.is_super_admin || user?.permissions?.includes("REJECT_PENALTY")) && (
                                <button
                                  style={styles.cancelButton}
                                  onClick={() => validerPenalite(p.id, false)}
                                  disabled={!p.est_valide}
                                  title="Annuler la pénalité"
                                >
                                  <FaTimes style={{ marginRight: 4, fontSize: '0.9rem' }} /> Annuler
                                </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-muted py-4"> {/* Modifier colSpan de 7 à 8 */}
                          Aucune pénalité enregistrée.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}
            </div>

          
            {pagination.totalPages > 1 && (
              <div className="card-footer d-flex justify-content-center mt-3 bg-transparent border-top-0">
                <nav>
                  <ul className="pagination mb-0">
                    <li className={`page-item ${!pagination.previous ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={handlePrevPage}
                        disabled={!pagination.previous || loading}
                        style={!pagination.previous ? styles.paginationDisabled : styles.paginationButton}
                      >
                        &laquo; Précédent
                      </button>
                    </li>
                    
                    {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, i) => {
                      let pageNum;
                      if (pagination.totalPages <= 5) {
                        pageNum = i + 1;
                      } else if (currentPage <= 3) {
                        pageNum = i + 1;
                      } else if (currentPage >= pagination.totalPages - 2) {
                        pageNum = pagination.totalPages - 4 + i;
                      } else {
                        pageNum = currentPage - 2 + i;
                      }

                      return (
                        <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(pageNum)}
                            disabled={loading}
                            style={currentPage === pageNum ? { ...styles.paginationButton, ...styles.paginationActive } : styles.paginationButton}
                          >
                            {pageNum}
                          </button>
                        </li>
                      );
                    })}

                    <li className={`page-item ${!pagination.next ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={handleNextPage}
                        disabled={!pagination.next || loading}
                        style={!pagination.next ? styles.paginationDisabled : styles.paginationButton}
                      >
                        Suivant &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
          {(user?.is_super_admin || user?.permissions?.includes("VIEW_PRIME")) && (
          <div className="mb-6 mt-4">
            <Link 
              to="/primes"
              style={styles.primesLink}
            >
              Voir les primes
            </Link>
          </div>
          )}
          {/* Modal employés concernés */}
          {showEmployesModal && (
            <div style={styles.modalOverlay} onClick={() => setShowEmployesModal(false)}>
              <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div style={styles.modalHeader}>
                  <h4 style={{ margin: 0, color: '#1B019B' }}>
                    Liste des employés concernés par les pénalités ({employesConcernes.length})
                  </h4>
                  <button 
                    onClick={() => setShowEmployesModal(false)}
                    style={styles.closeButton}
                  >
                    &times;
                  </button>
                </div>
                
                {loadingEmployes ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Chargement...</span>
                    </div>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Prénom</th>
                          <th>Nom</th>
                          <th>Poste</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employesConcernes.length > 0 ? (
                          employesConcernes.map((emp, index) => (
                            <tr key={emp.id}>
                              <td>{index + 1}</td>
                              <td>{emp.prenom}</td>
                              <td>{emp.nom}</td>
                              <td>{emp.poste || '-'}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center text-muted py-3">
                              Aucun employé concerné
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-5">
          <p className="text-muted">Sélectionnez une organisation pour commencer</p>
        </div>
      )}
    </div>
  );
};

export default PenalitesPage;